<div
    id="srs-review-modal-container"
    class="fixed inset-0 flex items-center justify-center"
>
    <div 
        id="srs-review-modal-content"
        class="relative flex flex-col p-10 bg-white sm:w-[600px] gap-y-4"
    >
        
        <div
            class="flex flex-row justify-between"
        >
            <div class="flex items-center">
                <span 
                    id="srs-review-modal-icon"
                    class="material-symbols-rounded icon-40"
                    [class.text-red-500]="modalIconColor === 'text-red-500'"
                    [class.text-green-500]="modalIconColor === 'text-green-500'"
                >
                    {{modalIcon}}
                </span>
            </div>
            <button 
                id="srs-review-modal-close-button"
                (click)="cancel()"
            >
                <span 
                    class="material-symbols-rounded text-grey-800 icon-24"
                >
                    {{ closeIcon }}
                </span>
            </button>
        </div>



        <h3 id="srs-review-modal-title"
        >{{modalTitle}}</h3>

        <div *ngIf="modalMessage && modalMessage.length > 0">
            <span 
                id="srs-review-modal-message"
                class="body-default-regular text-black">{{modalMessage}}
            </span>
        </div>

        <div class="flex flex-col">
            <label
                id="srs-review-modal-comment-label"
                for="srs-review-modal-comment"
                class="body-large-regular text-secondary">
                Comments
                
                <span 
                    *ngIf="requireComments"
                    id="srs-review-modal-comment-required"
                    class="body-large-regular text-red-500"
                >
                    *
                </span>
            </label>

            <form 
                [formGroup]="reviewForm" 
                class="flex flex-col">
                
                <app-text-area 
                    id="srs-review-modal-comment" 
                    formControlName="commentCtrl" 
                    [rows]="4"
                    [displayCharactersCount]="false"></app-text-area>

                <div class="flex flex-row flex-wrap gap-4">
                    <div class="flex flex-grow">
                        <button id="btn-srs-review-cancel" class="btn btn-secondary-grey w-full" type="button" (click)="cancel()">{{cancelButtonText}}</button>
                    </div>
                    <div class="flex flex-grow">
                        <button id="btn-srs-review-submit" class="btn btn-primary w-full" type="button" (click)="onSubmit()" [disabled]="reviewForm.invalid">{{submitButtonText}}</button>
                    </div>
                    
                    
                </div>
            </form>
        </div>
    </div>
</div>